export default __webpack_public_path__ + "./fonts/close.527f1e0f.svg";